import BusinessApps from '../../views/businessapps/BusinessApps.vue'

const routes = {
    path: '/:account_id/businessApps',
    name: 'businessApps',
    component: BusinessApps,
    children: []
}

export default routes
